function ArrivedStatus() {
  return (
    <div className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[16px] bg-[#E1F2F6] font-OpenSansSemiBold font-[600] text-[#128D87] text-[14px] leading-[20px] tracking-[0.14px] capitalize [mix-blend-mode:multiply]">
      Arrived
    </div>
  );
}

export default ArrivedStatus;
